import { DetailsHeader, DetailsListLayoutMode, IColumn, IDetailsHeaderProps, IDetailsHeaderStyles, IRenderFunction, ProgressIndicator, SelectionMode, ShimmeredDetailsList, Stack, Selection, useTheme, Icon, IDetailsColumnStyles, Link } from '@fluentui/react';
import * as React from 'react';
import { IInvoiceItemList } from '../../../../Models/Invoice/IInvoiceList';
import { StornoStateEnum } from '../../../../Models/Invoice/StornoStateEnum';

interface IInvoiceListViewProps {
    items: IInvoiceItemList[]
    isLoading: boolean;
    selectItem: (item: IInvoiceItemList) => void;
    showName?: boolean;
}


export const InvoiceListView: React.FunctionComponent<IInvoiceListViewProps> = (props) => {

    const theme = useTheme();
    const [selected, setSelected] = React.useState<IInvoiceItemList[]>([]);
    const [selectionState] = React.useState(new Selection({

        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IInvoiceItemList[];
            setSelected(selected);
        },
    }));

    React.useEffect(() => {
        if (selected.length > 0) {
           props.selectItem(selected[0]);
        }
    }, [selected])

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
           
        },
        cellTitle: {
        
        }
    }

    const headerStyleRight: Partial < IDetailsColumnStyles > = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,

        },
        cellTitle: {
            justifyContent: 'end'
        }
    }

    const formatPrice = (value?: number) => {
        return value?.toFixed(2);
    }

    const _columns: IColumn[] = props.showName ? [
        { key: 'invoiceNo', name: 'Doklad', fieldName: 'invoiceNo', minWidth: 80, maxWidth: 90, isResizable: true, styles: headerStyle },
        { key: 'variabil', name: 'Variabil', fieldName: 'variabil', minWidth: 80, maxWidth: 90, isResizable: true, isCollapsible: true, styles: headerStyle },
        { key: 'name', name: 'Zákazník', fieldName: 'name', minWidth: 80, maxWidth: 240, isResizable: true, styles: headerStyle },
        { key: 'invoiceValue', name: 'Celkem s DPH', fieldName: 'invoiceValue', minWidth: 80, maxWidth: 120, isResizable: true, styles: headerStyleRight },
        { key: 'invoicePaid', name: 'Zaplaceno', fieldName: 'invoicePaid', minWidth: 80, maxWidth: 120, isResizable: true, isCollapsible: true, styles: headerStyleRight },
        { key: 'created', name: 'Vystavena', fieldName: 'created', minWidth: 80, maxWidth: 100, isResizable: true, isCollapsible: true, styles: headerStyle },
        { key: 'due', name: 'Splatnost', fieldName: 'due', minWidth: 80, maxWidth: 100, isResizable: true, isCollapsible: true, styles: headerStyle },
        { key: 'icon', name: 'icon', minWidth: 40, maxWidth: 50, isIconOnly: true, isResizable: true, styles: headerStyle },
    ] : [
        { key: 'invoiceNo', name: 'Doklad', fieldName: 'invoiceNo', minWidth: 80, maxWidth: 90, isResizable: true, styles: headerStyle },
        { key: 'variabil', name: 'Variabil', fieldName: 'variabil', minWidth: 80, maxWidth: 90, isResizable: true, isCollapsible:true, styles: headerStyle },
        { key: 'invoiceValue', name: 'Celkem s DPH', fieldName: 'invoiceValue', minWidth: 80, maxWidth: 120, isResizable: true, styles: headerStyleRight },
        { key: 'invoicePaid', name: 'Zaplaceno', fieldName: 'invoicePaid', minWidth: 80, maxWidth: 120, isResizable: true, isCollapsible: true, styles: headerStyleRight },
        { key: 'created', name: 'Vystavena', fieldName: 'created', minWidth: 80, maxWidth: 100, isResizable: true, isCollapsible: true, styles: headerStyle },
        { key: 'due', name: 'Splatnost', fieldName: 'due', minWidth: 80, maxWidth: 100, isResizable: true, isCollapsible: true, styles: headerStyle },
        { key: 'icon', name: 'icon', minWidth: 40, maxWidth: 50, isIconOnly: true, isResizable: true, styles: headerStyle }];

    const renderItemColumn = (item: IInvoiceItemList, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IInvoiceItemList];

            const icon = (item.storno !== StornoStateEnum.None) ? "Cancel" : "PaymentCard";
            const iconStyle = item.storno !== StornoStateEnum.None ?
                (item.storno === StornoStateEnum.Waiting ? {root: { fontSize: 16, color: 'orange' } }: { root: { fontSize: 16, color: 'silver' } })
                            : ((item.invoicePaid >= item.invoiceValue) ? { root: { fontSize: 16, color: 'black' } }: { root: { fontSize: 16, color: 'red' } })


            const iconTitle = item.storno !== StornoStateEnum.None ?
                (item.storno === StornoStateEnum.Waiting ? 'Byl vytvořen požadavek na zrušení faktrury' : 'Faktura byla stornována')
                : ((item.invoicePaid >= item.invoiceValue) ? 'Zaplaceno' : 'Nezaplaceno')

            let color = theme.semanticColors.listText;
            if (item.storno === StornoStateEnum.Waiting) {
                color = 'orange';
            }
            if (item.due < new Date(Date.now()) && (item.invoicePaid < item.invoiceValue)) {
                color = 'red';
            }
            if (item.storno === StornoStateEnum.Storno) {
                color = 'silver';
            }

            switch (column.key) {
                case "invoiceNo":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}><Link onClick={() => props.selectItem(item)}>{fieldContent?.toString()}</Link></span>
                case "invoiceValue":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end', color: color }}>{formatPrice(fieldContent as number)}</span>
                case 'due':
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', color: color }}>{(fieldContent as Date)?.toLocaleDateString("cs-cz")}</span>
                case 'created':
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', color: color }}>{(fieldContent as Date)?.toLocaleDateString("cs-cz")}</span>
                case 'invoicePaid':
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end', color: color }}>{formatPrice(fieldContent as number)}</span>
                case 'icon':
                    return <div><Icon styles={iconStyle} iconName={icon} title={iconTitle} /></div>
                default:
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', color: color }}>{fieldContent?.toString()}</span>
            }
        }
        else {
            return (<div></div>)
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }



    return (<Stack styles={{ root: { paddingTop:0 } }}>
         
        <Stack styles={{ root: { height: 10 } }}>
            {props.isLoading ? <ProgressIndicator /> : null}
        </Stack>

        <ShimmeredDetailsList
            items={props.items}
            columns={_columns}
            setKey="set"
            onRenderDetailsHeader={onRenderDetailsHeader}
            selectionMode={SelectionMode.single}
            layoutMode={DetailsListLayoutMode.justified}
            onRenderItemColumn={renderItemColumn}
            selection={selectionState}
            selectionPreservedOnEmptyClick={false}
            ariaLabelForSelectionColumn="Výběr věkové skupiny"
            ariaLabelForSelectAllCheckbox="Výběr věkové skupiny"
            checkButtonAriaLabel="Vyber řádek"
            onItemInvoked={(item: IInvoiceItemList) => props.selectItem(item)}
        />

    </Stack>)
}